export const normalizeUrl = (url) => {
    if (!/^https?:\/\//i.test(url))
        return `https://${url}`;
    return url;
};

// agregar un 0 (cero) al mes para [key] de pedidos incompletos
// 1 => 01, 2 => 02
export const formatMonth = (m) => String(m).padStart(2, '0');